var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('admin-header',{attrs:{"name":_vm.$t('Special offers'),"add-new":_vm.addNewBtn},on:{"create":_vm.newSpecialOffer}}),_c('app-card',[_c('router-view',{attrs:{"name":"specialoffers"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }